import {BehaviorSubject} from 'rxjs';
import {browser$} from '@/streams/browser';
import {QtyType} from '@/const/contract';
import {readQtyTypeBeforeV2, readQtyTypeV2} from '@/storage/contract';

export const qtyTypeBeforeV2$ = new BehaviorSubject(QtyType.Coin);
export const qtyTypeV2$ = new BehaviorSubject(QtyType.Coin);

browser$.subscribe(() => {
  qtyTypeBeforeV2$.next(readQtyTypeBeforeV2());
  qtyTypeV2$.next(readQtyTypeV2());
});
